module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/registry_mobile-26c336966bd482266c93c3dd4390ca02.png";